import { render, staticRenderFns } from "./TableUserProjects.vue?vue&type=template&id=2f139eb6&"
import script from "./TableUserProjects.vue?vue&type=script&lang=js&"
export * from "./TableUserProjects.vue?vue&type=script&lang=js&"
import style0 from "./TableUserProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports